<template>
  <div>
        <el-dialog 
            :visible.sync="onShow" 
            width="600px"
            :z-index="9"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            center 
        >
            <div class="onDehalf-title mb-2">
                <div>设置订金</div>
                <!--关闭-->
                <span class="close" @click="$emit('onShow')"><i class="el-icon-close"></i></span>
            </div>
            <el-form label-position="right" :model="formLabelAlign" :rules="rules" ref="formLabelAlign" @submit.native.prevent>
                <el-form-item label="请输入订金" prop="deposit">
                <el-input v-model.number="formLabelAlign.deposit" type="number" ></el-input>
                </el-form-item>
                <el-form-item class="formbuttton">
                    <div  class="onDehalf-bottoms">
                        <el-button @click="$emit('onShow')">取消</el-button>
                        <el-button type="primary" @click="submitForm('formLabelAlign')">确认修改</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
  </div>
</template>

<script>
import { mapState,mapActions} from 'vuex'
export default {
  name: 'OrderModifyDeposit',
  components: {},   
  props: {
        orderDetail: {
            type: Object,
            default: () => {}
        },
        onShow: {
            type: Boolean,
            default: false
        }
  },
  data() {
    return {
        formLabelAlign: {
          deposit: '',
        },
        rules:{
          deposit: [
            { required: true, message: '订金不能为空', trigger: 'blur' },
            {
                validator: (rule, value, callback) => {
                // 为空已经被 required 拦截，这里判断长度
                if (value && value > (this.orderDetail.price-1-this.orderDetail.price_pay/100)) {
                    return callback(new Error('订金不能超过订单金额'))
                }
                callback()
                },
                trigger: 'blur'
            }
          ]
        },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_EditOrderHotelDeposit']),
    //代收款短信通知
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.POST_EditOrderHotelDeposit({
                data:{
                    ...this.formLabelAlign,
                    oid:this.orderDetail.oid
                },
                successFun: (res) => {
                    this.formLabelAlign.deposit='';
                    this.$emit('getorderDetail');
                    this._alert('修改成功');
                }
            });
            } else {
                return false;
            }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
    .onDehalf-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        text-align: center;
        position: relative;
    }
    .noHint{
        text-align: center;
        margin-top: 20px;
        .img{
            width: 200px;
        }
        p{
            margin-top: 14px;
            color:#999
        }
    }
    .close{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #999;
        background-color: #f3f4f8;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;
    }
    .onDehalf-bottoms{
        display: flex;
        justify-content:flex-end;
    }
</style>
